module.exports = __webpack_public_path__ + "static/media/top-teachers-video.30d48702.mp4";